<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Box Icon" pageTitle="Box Icon" />
            <BoxIcon />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import BoxIcon from '../BoxIcon/BoxIcon'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'BoxIconPage',
    components: {
        MainHeader,
        PageTitle,
        BoxIcon,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>